import { Link } from "react-router-dom";
import { Instagram, Linkedin, MessageCircle, Globe } from "lucide-react";
import IkaraLogo from "./IkaraLogo";

const Footer = () => {
  return (
    <footer 
      className="section-luxury"
      style={{ backgroundColor: '#1A1A1A' }}
      data-testid="footer"
    >
      <div className="container-luxury">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <div className="mb-6">
              <IkaraLogo variant="dark" showIcon={true} />
            </div>
            <p 
              className="text-base font-light max-w-sm mb-6 leading-relaxed"
              style={{ color: '#D1C9B8' }}
            >
              Artisanal space scenting from the house of Meilleur. 
              Crafting signature olfactory experiences for India's finest commercial spaces.
            </p>
            <p 
              className="text-xs tracking-widest uppercase"
              style={{ color: '#5C5A56', letterSpacing: '0.2em' }}
            >
              Made in India
            </p>
          </div>

          {/* Navigation Column */}
          <div className="md:col-span-3">
            <h4 
              className="text-xs tracking-widest uppercase mb-6"
              style={{ color: '#5C5A56', letterSpacing: '0.2em' }}
            >
              Navigation
            </h4>
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-home"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-about"
              >
                About
              </Link>
              <Link 
                to="/products" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-products"
              >
                Products
              </Link>
              <Link 
                to="/contact" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-contact"
              >
                Contact
              </Link>
              <Link 
                to="/contact" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-enquire"
              >
                Enquire Now
              </Link>
            </nav>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4">
            <h4 
              className="text-xs tracking-widest uppercase mb-6"
              style={{ color: '#5C5A56', letterSpacing: '0.2em' }}
            >
              Contact
            </h4>
            <div className="flex flex-col space-y-4">
              <a 
                href="mailto:hello@ikarascents.com" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-email"
              >
                hello@ikarascents.com
              </a>
              <a 
                href="tel:+918527499057" 
                className="text-sm font-light transition-opacity hover:opacity-70"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-phone"
              >
                +91 85274 99057
              </a>
              <a 
                href="https://www.ikarascents.com" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-light transition-opacity hover:opacity-70 flex items-center gap-2"
                style={{ color: '#F9F6F0' }}
                data-testid="footer-website"
              >
                <Globe className="w-4 h-4" />
                www.ikarascents.com
              </a>
              <address 
                className="not-italic text-sm font-light leading-relaxed"
                style={{ color: '#D1C9B8' }}
              >
                Delhi: B-72, Ashoka Enclave II,<br />
                Sector 37, Faridabad, 121003
              </address>
              <address 
                className="not-italic text-sm font-light leading-relaxed"
                style={{ color: '#D1C9B8' }}
              >
                Indore: Platinum Plaza, PU 4,<br />
                Behind C21 Mall, AB Road, 452010
              </address>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="mt-16 pt-8 border-t"
          style={{ borderColor: '#333333' }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p 
              className="text-xs"
              style={{ color: '#5C5A56' }}
            >
              © {new Date().getFullYear()} Ikara Scents. From the house of Meilleur. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a 
                href="https://instagram.com/ikarascents" 
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-70"
                style={{ color: '#D1C9B8' }}
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="transition-opacity hover:opacity-70"
                style={{ color: '#D1C9B8' }}
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="transition-opacity hover:opacity-70"
                style={{ color: '#D1C9B8' }}
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
